// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"88":"97bbbd20","132":"b7e056e0","179":"904b98fa","479":"e7158128","738":"c1328284"}[chunkId] + ".js";
};